import { render } from "./tablebox.html?vue&type=template&id=ae80320a&scoped=true&external"
import script from "./tablebox.ts?vue&type=script&lang=js&external"
export * from "./tablebox.ts?vue&type=script&lang=js&external"

import "./tablebox.scss?vue&type=style&index=0&id=ae80320a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae80320a"],['__file',"src/components/ui/tablebox/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae80320a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae80320a', __exports__)) {
    api.reload('ae80320a', __exports__)
  }
  
  module.hot.accept("./tablebox.html?vue&type=template&id=ae80320a&scoped=true&external", () => {
    api.rerender('ae80320a', render)
  })

}


export default __exports__